import R from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import { Row, Col } from 'react-bootstrap';
import PhotoContainer from '../PhotoContainer';
import actions from '../../redux/actions';
import InviteOther from '../Deals/InviteOther';

class TeamOthers extends Component {
  constructor() {
    super();
    this.state = {
      showAll: true,
      members: [],
      others: [],
      showInviteModal: false,
    };
  }

  componentWillMount() {
    const { team } = this.props;
    if (team) {
      this.props.loadMembers(team.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { members } = nextProps;
    const { others } = this.state;

    if (members && others) {
      this.setState({ members: members.concat(others) });
    }
  }

  handleInviteOthers(e) {
    e.preventDefault();
    this.setState({ showInviteModal: true });
  }

  handleCloseInviteModal() {
    this.setState({ showInviteModal: false });
  }

  addOther(other) {
    let { others } = this.state;
    const index = R.findIndex(R.propEq('email', other.email))(others);

    if (index === -1) {
      others.push(other);
    }

    this.setState({ members: this.props.members.concat(others) });
    this.props.onUpdateOthers(others);
  }

  renderMembers() {
    const members = this.state.showAll
      ? this.state.members
      : this.state.members.slice(0, 3);

    if (members && members.length) {
      return members.map((member, i) => {
        return (
          <Row key={i} className="team-member cursor-hand">
            <Col sm={12}>
              <hr className="border" />
            </Col>
            <Col md={4}>
              <PhotoContainer
                className="photo-container"
                image={member.user_info ? member.user_info.avatar : ''}
                defaultImg="user"
              />
            </Col>
            <Col md={5}>
              <span>
                {member.user_info ? member.user_info.name : member.name}
              </span>
            </Col>
          </Row>
        );
      });
    } else {
      return <p>No members</p>;
    }
  }

  renderShowToggle() {
    if (this.state.members.length > 3) {
      if (this.state.showAll) {
        return (
          <div className="text-right">
            <hr className="border" />
            <a
              className="list-all"
              onClick={() => this.setState({ showAll: false })}
            >
              Show less
            </a>
          </div>
        );
      } else {
        return (
          <div className="text-right">
            <hr className="border" />
            <a
              className="list-all"
              onClick={() => this.setState({ showAll: true })}
            >
              List all
            </a>
          </div>
        );
      }
    }
  }

  renderInvite() {
    return (
      <div className="invite-others">
        <hr className="border" />
        <div className="new-item" onClick={(e) => this.handleInviteOthers(e)}>
          <div className="icon-container">
            <div className="new-icon">
              <FontAwesome name="plus" />
            </div>
          </div>
          <div className="new-text">
            <span className="text-gray">Invite Others</span>
          </div>
        </div>
        <InviteOther
          show={this.state.showInviteModal}
          onClose={() => this.handleCloseInviteModal()}
          type="create-deal"
          onSave={(other) => this.addOther(other)}
        />
      </div>
    );
  }

  render() {
    const { team } = this.props;

    return team ? (
      <div className="team-module">
        <div className="team">
          <div className="top">
            <div className="team-photo">
              <PhotoContainer
                className="photo-container"
                image={team.avatar}
                defaultImg="team"
              />
            </div>
            <div className="team-title">{team.name}</div>
          </div>
          <div className="team-members">
            {this.renderMembers()}
            {this.renderInvite()}
            {this.renderShowToggle()}
          </div>
        </div>
      </div>
    ) : null;
  }
}

const mapStateToProps = (state) => ({
  team: state.teams.selectedTeam,
  status: state.users.status,
  members: state.users.members,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  loadMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamOthers);



// WEBPACK FOOTER //
// src/components/Agreements/TeamOthers.jsx